import React, { useEffect, useState } from "react";
import ProductCard from "../../components/product_card/ProductCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import "./Productscards.css";

// let productsarr = [
//   "28",
//   "51",
//   "122",
//   "57",
//   "43",
//   "58",
//   "135",
//   "110",
//   "106",
//   "150",
//   "141",
//   "174",
//   "159",
// ];
const Productscardscontainer = () => {
  const [Items, setItems] = useState([]);
  const LoadSeveralProducts = () => {
    let ourapi = `https://rus-digital-televisions.onrender.com/allproduct`;
    fetch(ourapi)
      .then((res) => res.json())
      .then((data) => setItems(data.splice(60, 80)));
  };

  useEffect(() => {
    LoadSeveralProducts();
  }, []);
  return (
    <>
      <div className="productsCards-body">
        <div className="Navigation">
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
        <div className="productscards_content py-4">
          <Swiper
            style={{ height: "496px" }}
            loop={true}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              // when window width is >= 480px
              480: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
            pagination={{
              clickable: true,
            }}
            navigation={{
              clickable: true,
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            modules={[Navigation]}
            className="mySwiper productsSwipper"
            style={{ height: "457px" }}
          >
            {Items
              ? Items.map((product) => {
                  return (
                    <SwiperSlide key={product.id}>
                      <ProductCard
                        productimg={product.img}
                        name={product.name.slice(0, 50)}
                        discount={product.discount}
                        price={product.price}
                        productdetails={product}
                      />
                    </SwiperSlide>
                  );
                })
              : console.log("loading")}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Productscardscontainer;
